import { render, staticRenderFns } from "./AdvanceRequisiteRule.vue?vue&type=template&id=3589d80d&"
import script from "./AdvanceRequisiteRule.vue?vue&type=script&lang=js&"
export * from "./AdvanceRequisiteRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports